const tokObfuscate = (token: string): string => {
    if (token) {
        //token = token.replace(/tok[_|0]/g, "");
        let regex = /(^tok[0-9|_])(.{3})(.*)(.{3}$)/;
        let obfuscateThis = token.match(regex);
        if (obfuscateThis) {
            const t_ = token.replace(
                regex,
                "$1$2" + "*".repeat(obfuscateThis[3].length) + "$4"
            );
            return t_;
        } else {
            return token;
        }
    }

    return "";
}

export { tokObfuscate };